import { InfoCircleFilled, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Flex,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Switch,
  Tooltip,
  Typography,
} from 'antd';
import { CountdownProps } from 'antd/lib';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconArrive from '../../assets/images/booking/icon-arrive.svg';
import iconDepart from '../../assets/images/booking/icon-depart.svg';
import iconDown from '../../assets/images/booking/icon-down.svg';
import iconEmail from '../../assets/images/booking/icon-mail.svg';
import iconName from '../../assets/images/booking/icon-name.svg';
import iconPhone from '../../assets/images/booking/icon-phone.svg';
import iconBookingAgent from '../../assets/images/ic-booking-agent.svg';
import iconCancelPinCode from '../../assets/images/ic-cancel-pincode.svg';
import iconNumpad from '../../assets/images/ic-numpad.svg';
import '../../assets/styles/desktop/busBooking.scss';
import ModalInfoInsurance from '../../components/Modal/ModalInfoInsurance';
import ModalNumpad from '../../components/Modal/ModalNumpad';
import { Constant, Toast, USER_GROUP, YearFormat } from '../../config/constant';
import { convertTimeFormat, filterOption, filterOptionAgent, formattedPrice } from '../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { listAgentSelector } from '../../redux/slice/agents/listAgentSlice';
import { selectAuth } from '../../redux/slice/authSlice';
import { getCheckBookingV2 } from '../../redux/slice/bookings/checkBookingSlice';
import {
  createBookingSelector,
  createBookingV2,
  getPriceBooking,
  resetBooking,
  resetPriceBooking,
  setBookingForAgentId,
  setPinCode,
} from '../../redux/slice/bookings/createBookingSlice';
import { destroyBooking, resetDestroyBooking } from '../../redux/slice/bookings/destroyBookingSlice';
import { resetAssistBooking } from '../../redux/slice/bookings/getAssistBookingSlice';
import {
  getTicketCodeBooking,
  getTicketCodeSelector,
  resetTicketCode,
} from '../../redux/slice/bookings/getTicketCodeSlice';
import { holdingBookingSelector, resetDataBooking } from '../../redux/slice/bookings/holdingBookingSlice';
import { getBookingInfoV2, getListFilterBooking, listBookingSelector } from '../../redux/slice/bookings/listBooking';
import { setToast } from '../../redux/slice/toastNotifySlice';
import { paymentAgentOptions, paymentMultiOptions, validatorEmailBooking } from '../../utils/bookingItem';
import { getPriceScheduleReason } from '../../utils/helpers';
import ModalMultiBooking1 from './ModalMultiBooking1';

const ModalMultiBooking: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  listBooking,
  formSearch,
  isMulti,
  targetTime,
  setTargetTicket,
  isBookingNoDiagram,
  isDepart,
}) => {
  const { listCustomers, price, booking_for_agent_id, pin_code } = useAppSelector(createBookingSelector);
  const { listAgentActive } = useAppSelector(listAgentSelector);
  const { group } = useAppSelector(selectAuth);
  const { ticketCode, loading: loadingTicket } = useAppSelector(getTicketCodeSelector);
  const { dataBooking, loading: loadingHold } = useAppSelector(holdingBookingSelector);
  const { status: statusCreateUpdate } = useAppSelector(createBookingSelector);
  const { listDataSegmentBooking, loading: loadingCheckSegment } = useAppSelector((state) => state.checkBooking);
  const { dataSearchBooking } = useAppSelector(listBookingSelector);
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const [activeKey, setActiveKey] = useState<string>('1');
  const [paymentMethod, setPaymentMethod] = useState(undefined);
  const [otp, setOtp] = useState<string>('');
  const [openInfoInsurance, setOpenInfoInsurance] = useState(false);
  const [numCustomer, setNumCustomer] = useState<number>(1);
  const [customerPhone, setCustomerPhone] = useState<string>('');
  const [countdownFinished, setCountdownFinished] = useState(false);
  const [commissionPrice, setCommissionPrice] = useState(0);
  const [openModalNumpad, setOpenModalNumpad] = useState<boolean>(false);
  const [listLocationDepart, setListLocationDepart] = useState<any>([]);
  const [listLocationArrive, setListLocationArrive] = useState<any>([]);
  const [listAmountGroupSeat, setListAmountGroupSeat] = useState<any>([]);
  const [formBooking]: [FormInstance] = Form.useForm();
  const provinceId = Form.useWatch('route_id', formSearch);
  const searchDepartTime = Form.useWatch('depart_time', formSearch);
  const pickUpValue = Form.useWatch('pickup_location_id', formBooking);
  const dropOffValue = Form.useWatch('drop_off_location_id', formBooking);
  const isInSurance = Form.useWatch('is_insurance', formBooking);
  const customInfo = Form.useWatch('custom_info', formBooking);
  const isRepresent = Form.useWatch('is_represent', formBooking);
  const isAgentId = Form.useWatch('is_agent_id', formBooking);
  const isAgentIdMulti = Form.useWatch('is_agent_id_multi', formBooking);
  const agentId = Form.useWatch('agent_id', formBooking);
  const agentIdMulti = Form.useWatch('agent_id_multi', formBooking);
  const commisionPrice = Form.useWatch('commission_price', formBooking);
  const watchSegmentId = Form.useWatch('segment_id', formBooking);
  const watchGroupSeat = Form.useWatch('group_seat', formBooking);
  const searchDateBooking = dayjs(Form.useWatch('date_booking', formSearch)).format(YearFormat);
  const { Countdown } = Statistic;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    onCancel();
    dispatch(resetTicketCode());
    setNumCustomer(1);
    dispatch(resetPriceBooking());
    dispatch(resetDataBooking());
    showTab('1');
    setOpenModalNumpad(false);
    const multiTicket = dataBooking?.length && dataBooking?.map((item: any) => item?.ticket_code);
    formBooking.resetFields();
    if (listBooking?.schedule?.is_diagram) {
      const tmpDataDestroy = {
        ticket_code: multiTicket,
      };
      dispatch(destroyBooking(tmpDataDestroy));
    }
    if (!listBooking?.schedule?.is_diagram) {
      setTargetTicket(undefined);
    }
    setCountdownFinished(false);
  };
  const onChange: CountdownProps['onChange'] = (val) => {};
  const showTab = (key: string) => {
    setActiveKey(key);
  };
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formBooking.scrollToField(firstErrorField.name);
    }
  };
  const onFinishCountdown: CountdownProps['onFinish'] = () => {
    setTargetTicket(undefined);
    setCountdownFinished(true);
  };
  const onChangePayment = ({ target: { value } }: RadioChangeEvent) => {
    setPaymentMethod(value);
  };

  const handleUpCustomer = () => {
    if (dataSearchBooking?.empty_seat && !listBooking?.schedule?.is_diagram) {
      if (numCustomer < +dataSearchBooking?.empty_seat) {
        setNumCustomer(numCustomer + 1);
      }
    } else {
      setNumCustomer(numCustomer + 1);
    }
  };
  const handleDownCustomer = () => {
    if (numCustomer > 1) {
      setNumCustomer(numCustomer - 1);
    }
  };
  const handleChangeSegment = (value: any, option: any) => {
    setListLocationDepart(option?.transship_depart?.length > 0 ? option?.transship_depart : []);
    setListLocationArrive(option?.transship_arrive?.length > 0 ? option?.transship_arrive : []);
    setListAmountGroupSeat(option?.amount);
  };
  const groupSeatOption = () => {
    return listBooking?.schedule?.bus_type?.seat_map?.group_seat?.length
      ? listBooking?.schedule?.bus_type?.seat_map?.group_seat?.map((group: any) => ({
          label: <span className={group.group_color}>{group.name}</span>,
          value: group.name,
          disabled: listAmountGroupSeat?.[group.name] === 0,
        }))
      : [];
  };
  const handleOptionPickup = () => {
    let options: any = [];
    if (listLocationDepart?.length) {
      options = options.concat(
        listLocationDepart?.length
          ? listLocationDepart?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listBooking?.schedule?.is_depart_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const handleOptionDropOff = () => {
    let options: any = [];
    if (listLocationArrive?.length) {
      options = options.concat(
        listLocationArrive?.length
          ? listLocationArrive?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (listBooking?.schedule?.is_arrive_transship) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const onChangePhone = (value: string) => {
    const selectedCustomer = listCustomers?.length && listCustomers?.find((customer: any) => customer.phone === value);
    if (selectedCustomer) {
      formBooking.setFieldsValue({
        customer_name: selectedCustomer.name,
        customer_email: selectedCustomer.email,
        customer_phone: selectedCustomer.phone,
      });
    }
  };
  const handleInputChange = (value: string) => {
    setCustomerPhone(value);
    setCustomerPhone(value);
  };
  const onCancelSuccess = useCallback(() => {
    onCancel();
    dispatch(resetTicketCode());
    setOpenModalNumpad(false);
    setNumCustomer(1);
    dispatch(resetPriceBooking());
    dispatch(resetDataBooking());
    showTab('1');
    dispatch(resetDestroyBooking());
    dispatch(resetBooking());
    formBooking.resetFields();
    dispatch(getListFilterBooking({ depart_date: searchDateBooking }));
    if (isMulti) {
      dispatch(
        getBookingInfoV2({
          route_id: provinceId,
          depart_date: searchDateBooking,
          depart_time: convertTimeFormat(searchDepartTime),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, provinceId, searchDateBooking, searchDepartTime]);
  const onFinish = (values: any) => {
    if (numCustomer === 1 && !listBooking?.schedule?.is_diagram) {
      if (
        ((values.pickup_location_id && values.pickup_location_id !== 'other') ||
          (pickUpValue === 'other' && values.pickup_extra && values.pickup_extra.trim().length >= 3)) &&
        ((values.drop_off_location_id && values.drop_off_location_id !== 'other') ||
          (dropOffValue === 'other' && values.drop_off_extra?.trim().length >= 3)) &&
        values.payment_method
      ) {
        const tmpDataNoDiagram = {
          segment_id: values.segment_id,
          is_diagram: false,
          schedule_id: listBooking?.schedule?.id,
          depart_date: searchDateBooking,
          booking_type: Constant.BOOKING_MULTI_CUSTOM,
          payment_method: values.payment_method,
          is_insurance: values.is_insurance ? values.is_insurance : false,
          note: values.note,
          custom_info: [
            {
              ticket_code: ticketCode[0],
              customer_phone: values.customer_phone,
              customer_name: values.customer_name,
              customer_email: values.customer_email,
              drop_off_location_id: dropOffValue === 'other' ? null : values.drop_off_location_id,
              pickup_location_id: pickUpValue === 'other' ? null : values.pickup_location_id,
              pickup_extra: pickUpValue === 'other' ? values.pickup_extra : undefined,
              drop_off_extra: dropOffValue === 'other' ? values.drop_off_extra : undefined,
              group_seat: values.group_seat,
            },
          ],
          // contact_email: values.contact_email,
          // contact_phone: values.contact_phone,
          // contact_name: values.contact_name,
          // contact_note: values.contact_note,
          booking_for_agent: values.is_agent_id ? values.is_agent_id : false,
          agent_id: isAgentId ? values.agent_id : undefined,
          price_change: pin_code ? +values.total_price : undefined,
          pin_code: pin_code ? pin_code : undefined,
        };
        dispatch(setBookingForAgentId(values.agent_id));
        dispatch(createBookingV2(tmpDataNoDiagram));
      } else {
        if (!values?.payment_method) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập phương thức thanh toán',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
        if (
          (values.pickup_location_id === 'other' && !values.pickup_extra?.trim()) ||
          (values.drop_off_location_id === 'other' && !values.drop_off_extra?.trim())
        ) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập điểm trung chuyển khác',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
        if (!dropOffValue || !pickUpValue) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập điểm đi và điểm đến',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
      }
    } else {
      if (!values?.payment_method_multi) {
        dispatch(
          setToast({
            message: 'Vui lòng nhập phương thức thanh toán',
            status: true,
            type: Toast.TYPE_ERROR,
          }),
        );
      } else {
        if (isRepresent) {
          if (
            customInfo[0]?.customer_name &&
            customInfo[0]?.customer_phone &&
            customInfo[0]?.pickup_location_id &&
            customInfo[0]?.drop_off_location_id
          ) {
            const customIsRepresent = values.custom_info.reduce((acc: any, obj: any) => {
              const { seat, pickup_location_id, drop_off_location_id, ...rest } = obj;
              acc[seat] = {
                ...rest,
                customer_email: customInfo[0]?.customer_email,
                customer_name: customInfo[0]?.customer_name,
                customer_phone: customInfo[0]?.customer_phone,
                drop_off_location_id:
                  customInfo[0]?.drop_off_location_id === 'other' ? null : customInfo[0]?.drop_off_location_id,
                pickup_location_id:
                  customInfo[0]?.pickup_location_id === 'other' ? null : customInfo[0]?.pickup_location_id,
                pickup_extra: customInfo[0]?.pickup_location_id === 'other' ? customInfo[0]?.pickup_extra : undefined,
                drop_off_extra: customInfo[0]?.drop_off_extra === 'other' ? customInfo[0]?.drop_off_extra : undefined,
              };
              return acc;
            }, {});
            const customNoDiagramIsPresent = values.custom_info.reduce((acc: any, obj: any, index: number) => {
              const { pickup_location_id, drop_off_location_id, ...rest } = obj;
              const num = index;
              acc[num] = {
                ...rest,
                customer_email: customInfo[0]?.customer_email,
                customer_name: customInfo[0]?.customer_name,
                customer_phone: customInfo[0]?.customer_phone,
                drop_off_location_id:
                  customInfo[0]?.drop_off_location_id === 'other' ? null : customInfo[0]?.drop_off_location_id,
                pickup_location_id:
                  customInfo[0]?.pickup_location_id === 'other' ? null : customInfo[0]?.pickup_location_id,
                pickup_extra: customInfo[0]?.pickup_location_id === 'other' ? customInfo[0]?.pickup_extra : undefined,
                drop_off_extra: customInfo[0]?.drop_off_extra === 'other' ? customInfo[0]?.drop_off_extra : undefined,
                group_seat: customInfo[0]?.group_seat ?? undefined,
              };
              return acc;
            }, {});
            const multiTicket = dataBooking?.length && dataBooking?.map((item: any) => item?.ticket_code);
            const dataCreateBooking = {
              segment_id: values.segment_id,
              is_diagram: listBooking?.schedule?.is_diagram ? true : false,
              schedule_id: listBooking?.schedule?.id,
              depart_date: searchDateBooking,
              booking_type: Constant.BOOKING_MULTI_CUSTOM,
              ticket_code: listBooking?.schedule?.is_diagram ? multiTicket : ticketCode,
              custom_info: listBooking?.schedule?.is_diagram ? customIsRepresent : customNoDiagramIsPresent,
              payment_method: values.payment_method_multi,
              price: values.price_multi,
              is_insurance: values.is_insurance_multi ? values.is_insurance_multi : false,
              amount: listBooking?.schedule?.is_diagram ? undefined : numCustomer,
              contact_email: values.contact_email,
              contact_phone: values.contact_phone,
              contact_name: values.contact_name,
              contact_note: values.contact_note,
              booking_for_agent: values.is_agent_id_multi ? values.is_agent_id_multi : false,
              agent_id: isAgentIdMulti ? values.agent_id_multi ?? values.agent_id : undefined,
              price_change: pin_code ? +values.price_multi : undefined,
              pin_code: pin_code ? pin_code : undefined,
            };
            dispatch(setBookingForAgentId(values.agent_id));
            dispatch(createBookingV2(dataCreateBooking));
          } else {
            dispatch(
              setToast({
                message: 'Vui lòng nhập đủ thông tin người đại diện',
                status: true,
                type: Toast.TYPE_ERROR,
              }),
            );
          }
        } else {
          const customInfoObject = values.custom_info.reduce((acc: any, obj: any) => {
            const { seat, ticket_code, pickup_location_id, drop_off_location_id, ...rest } = obj;
            const pickupLocationId = pickup_location_id === 'other' ? null : pickup_location_id;
            const dropOffLocationId = drop_off_location_id === 'other' ? null : drop_off_location_id;
            acc[seat] = {
              ...rest,
              pickup_location_id: pickupLocationId,
              drop_off_location_id: dropOffLocationId,
              ticket_code: ticket_code,
            };
            return acc;
          }, {});

          const customNoDiagramObject = values.custom_info.reduce((acc: any, obj: any, index: number) => {
            const { ticket_code, pickup_location_id, drop_off_location_id, group_seat, ...rest } = obj;
            const pickupLocationId = pickup_location_id === 'other' ? null : pickup_location_id;
            const dropOffLocationId = drop_off_location_id === 'other' ? null : drop_off_location_id;
            const num = index;
            acc[num] = {
              ...rest,
              pickup_location_id: pickupLocationId,
              drop_off_location_id: dropOffLocationId,
              ticket_code: ticket_code,
              group_seat: group_seat,
            };
            return acc;
          }, {});
          if (customInfoObject) {
            const isCheckBooking = Object.values(customInfoObject).every((obj: any) => {
              return (
                (obj.pickup_location_id !== undefined || obj.pickup_extra !== undefined) &&
                (obj.drop_off_location_id !== undefined || obj.drop_off_extra !== undefined)
              );
            });
            if (isCheckBooking) {
              const dataCreateBooking = {
                segment_id: values.segment_id,
                is_diagram: listBooking?.schedule?.is_diagram ? true : false,
                schedule_id: listBooking?.schedule?.id,
                depart_date: searchDateBooking,
                booking_type: Constant.BOOKING_MULTI_CUSTOM,
                custom_info: listBooking?.schedule?.is_diagram ? customInfoObject : customNoDiagramObject,
                payment_method: values.payment_method_multi,
                price: values.price_multi,
                is_insurance: values.is_insurance_multi ? values.is_insurance_multi : false,
                amount: listBooking?.schedule?.is_diagram ? undefined : numCustomer,
                contact_email: values.contact_email,
                contact_phone: values.contact_phone,
                contact_name: values.contact_name,
                contact_note: values.contact_note,
                booking_for_agent: values.is_agent_id_multi ? values.is_agent_id_multi : false,
                agent_id: isAgentIdMulti ? values.agent_id_multi ?? values.agent_id : undefined,
                price_change: pin_code ? +values.price_multi : undefined,
                pin_code: pin_code ? pin_code : undefined,
              };
              dispatch(createBookingV2(dataCreateBooking));
              dispatch(setBookingForAgentId(values.agent_id));
            } else {
              dispatch(
                setToast({
                  message: 'Vui lòng nhập điểm đón trả',
                  status: true,
                  type: Toast.TYPE_ERROR,
                }),
              );
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    if (statusCreateUpdate === Constant.DEFAULT_STATUS) {
      onCancelSuccess();
      dispatch(resetAssistBooking());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCreateUpdate]);

  const onChangeIsAgent = () => {
    const currentChecked = formBooking.getFieldValue('is_agent_id');
    formBooking.setFieldsValue({ is_agent_id: !currentChecked });
    if (isAgentId && booking_for_agent_id) {
      formBooking.setFieldValue('agent_id', booking_for_agent_id);
    }
  };
  const handleChangeAgentIdOption = (option: any) => {
    setCommissionPrice(option?.commission_percent);
  };
  const listSegmentOption = listDataSegmentBooking?.length
    ? listDataSegmentBooking?.map((item: any) => {
        return {
          value: item?.segment_id,
          label: `${item?.start_location?.name} - ${item?.end_location?.name}`,
          transship_depart: item?.transship_depart,
          transship_arrive: item?.transship_arrive,
          time: item?.time,
          available_seats: item?.available_seats,
          amount: item?.amount,
          price_schedule: item?.price_schedule,
        };
      })
    : [];
  const handleNumpadClick = () => {
    if (pin_code) {
      dispatch(setPinCode(null));
    } else {
      setOtp('');
      setOpenModalNumpad(true);
    }
  };
  const listAgentActiveOption = listAgentActive?.length
    ? listAgentActive?.map((item: any) => {
        return {
          commission_percent: item?.commission_percent,
          value: item?.id,
          label: (
            <div className="d-flex items-center gap-x-2">
              <img src={iconBookingAgent} alt="" />
              {item?.name}
            </div>
          ),
          searchText: item?.name?.toLowerCase() || '',
        };
      })
    : [];
  useEffect(() => {
    if (dataBooking?.length > 0 && isMulti && watchSegmentId) {
      dispatch(
        getPriceBooking({
          segment_id: watchSegmentId,
          booking_type: Constant.BOOKING_MULTI_CUSTOM,
          schedule_id: listBooking?.schedule?.id,
          seat_number: dataBooking?.length && dataBooking?.map((item: any) => item?.seat_number),
          depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          is_insurance: false,
          agent_id: isAgentId && agentId ? agentId : undefined,
          group_seat: watchGroupSeat,
        }),
      );
      const totalPrice = dataBooking?.length && dataBooking?.reduce((sum: any, ticket: any) => sum + ticket.price, 0);
      formBooking.setFieldsValue({
        price: dataBooking?.price,
        price_multi: formattedPrice(totalPrice),
        commission_price: formattedPrice(
          listBooking?.schedule?.agent?.commission_percent
            ? (totalPrice * (100 - +listBooking?.schedule?.agent?.commission_percent)) / 100
            : totalPrice,
        ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    watchSegmentId,
    dataBooking,
    formBooking,
    isMulti,
    listBooking?.schedule?.agent?.commission_percent,
    isAgentId,
    agentId,
    watchGroupSeat,
  ]);

  useEffect(() => {
    if (listBooking?.schedule?.id && modalOpen && numCustomer && !listBooking?.schedule?.is_diagram && watchSegmentId) {
      if (numCustomer === 1) {
        dispatch(
          getPriceBooking({
            segment_id: watchSegmentId,
            booking_type: Constant.BOOKING_SINGLE,
            schedule_id: listBooking?.schedule?.id,
            amount: numCustomer,
            is_insurance: isInSurance ? isInSurance : false,
            pickup_location_id: pickUpValue && pickUpValue !== 'other' ? pickUpValue : null,
            drop_off_location_id: dropOffValue && dropOffValue !== 'other' ? dropOffValue : null,
            depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            agent_id: isAgentId && agentId ? agentId : undefined,
            group_seat: watchGroupSeat,
          }),
        );
      }
      if (numCustomer > 1) {
        const isMultiInsurance = formBooking.getFieldValue('is_insurance_multi');
        const scheduleId = listBooking?.schedule?.id;
        if (scheduleId && dataBooking) {
          dispatch(
            getPriceBooking({
              segment_id: watchSegmentId,
              booking_type: Constant.BOOKING_MULTI_CUSTOM,
              schedule_id: scheduleId,
              is_insurance: isMultiInsurance,
              depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              amount: numCustomer,
              agent_id: isAgentIdMulti && agentIdMulti ? agentIdMulti : undefined,
              group_seat: watchGroupSeat,
            }),
          );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    modalOpen,
    pickUpValue,
    isInSurance,
    dropOffValue,
    listBooking,
    numCustomer,
    isAgentId,
    agentId,
    watchSegmentId,
    watchGroupSeat,
  ]);

  useEffect(() => {
    if (listBooking?.schedule?.is_diagram) {
      if (price && !customInfo?.length) {
        formBooking.setFieldValue('price', price);
      }
      if (price && customInfo?.length > 0) {
        formBooking.setFieldValue('price_multi', price?.total_price);
        formBooking.setFieldValue('commission_price', price?.commission_price);
      }
    } else {
      if (!!price && numCustomer > 1) {
        if (activeKey === '1') {
          formBooking.setFieldValue('price_multi', price?.total_price);
          formBooking.setFieldValue('commission_price', price?.commission_price);
        }
      }
    }
  }, [price, formBooking, customInfo, listBooking, numCustomer, activeKey]);

  useEffect(() => {
    if (price && !listBooking?.schedule?.is_diagram && numCustomer === 1) {
      formBooking.setFieldValue('total_price', price?.total_price);
    }
    if (price && !listBooking?.schedule?.is_diagram && numCustomer === 1 && group === USER_GROUP.AGENT) {
      formBooking.setFieldValue('commission_price', price?.commission_price);
    }
    if (price && !listBooking?.schedule?.is_diagram && isAgentId && agentId) {
      formBooking.setFieldValue('commission_price', price?.commission_price);
    }
  }, [price, formBooking, listBooking, numCustomer, group, isAgentId, agentId]);
  useEffect(() => {
    if (ticketCode && activeKey !== '2' && !listBooking?.schedule?.is_diagram) {
      formBooking.setFieldValue('ticket_code', ticketCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketCode, listBooking, activeKey]);

  useEffect(() => {
    if (!listBooking?.schedule?.is_diagram && numCustomer && isBookingNoDiagram) {
      dispatch(getTicketCodeBooking(numCustomer));
      formBooking.setFieldValue('num_customer', numCustomer);
      const checkBookingData = {
        schedule_id: +listBooking?.schedule?.id,
        depart_date: searchDateBooking,
        is_diagram: listBooking?.schedule?.is_diagram,
        amount: numCustomer,
      };
      dispatch(getCheckBookingV2(checkBookingData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numCustomer, dispatch, listBooking, isBookingNoDiagram]);

  useEffect(() => {
    if (countdownFinished) {
      modalHandleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdownFinished]);

  useEffect(() => {
    if (booking_for_agent_id) {
      formBooking.setFieldValue('agent_id', booking_for_agent_id);
    }
  }, [booking_for_agent_id, formBooking]);
  useEffect(() => {
    if (listBooking?.count_segment === 1 && listDataSegmentBooking?.length) {
      if (listDataSegmentBooking[0]?.segment_id) {
        formBooking.setFieldValue('segment_id', listDataSegmentBooking[0]?.segment_id);
        setListAmountGroupSeat(listDataSegmentBooking[0]?.amount);
        setListLocationDepart(
          listDataSegmentBooking[0]?.transship_depart?.length > 0 ? listDataSegmentBooking[0]?.transship_depart : [],
        );
        setListLocationArrive(
          listDataSegmentBooking[0]?.transship_arrive?.length > 0 ? listDataSegmentBooking[0]?.transship_arrive : [],
        );
      }
    }
  }, [listBooking?.count_segment, listDataSegmentBooking]);
  return (
    <>
      <Modal
        open={isModalOpen}
        onOk={modalHandleOk}
        onCancel={modalHandleCancel}
        cancelText={cancelText}
        okText={okText}
        footer={[]}
        centered
        width={916}
        confirmLoading={loadingHold || loadingCheckSegment}
        className="modal-bus-booking diagram"
        maskClosable={false}
      >
        <Card className="card-modal-booking">
          <Form
            layout="vertical"
            className="mt-2 form-booking-multi"
            form={formBooking}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            name="form-booking-diagram"
            labelAlign={'left'}
            initialValues={{
              is_insurance_multi: false,
              is_represent: false,
              is_agent_id: false,
            }}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
          >
            <Row
              style={{
                paddingBottom: 4,
                borderBottom: '1px solid #EEEEEE',
              }}
              className="d-flex space-between items-center"
            >
              <Typography.Text className="fw-600 fs-18 ">{t('Thông tin hành khách')}</Typography.Text>
              <div style={{ marginRight: '38px' }}>
                <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Col>
                    <Countdown
                      className="countdown-booking booking-modal"
                      title="Thời gian còn lại:"
                      value={targetTime}
                      onChange={onChange}
                      format="mm:ss"
                      onFinish={onFinishCountdown}
                    />
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              {!listBooking?.schedule?.is_diagram && (
                <Col className="d-flex mt-2">
                  <Typography className="fs-16 fw-500">
                    Vui lòng chọn số lượng hành khách <span style={{ color: '#D81717' }}>*</span>
                  </Typography>
                  <div className="block-num-customer">
                    <Button className="btn-num btn-up" onClick={() => handleDownCustomer()}>
                      <span className="icon">
                        <MinusOutlined />
                      </span>
                    </Button>
                    <Typography className="fw-500 fs-16">{numCustomer}</Typography>
                    <Button
                      className="btn-num btn-down"
                      disabled={
                        dataSearchBooking?.empty_seat &&
                        !listBooking?.schedule?.is_diagram &&
                        +dataSearchBooking?.empty_seat === numCustomer
                      }
                      onClick={() => handleUpCustomer()}
                    >
                      <span className="icon">
                        <PlusOutlined />
                      </span>
                    </Button>
                  </div>
                  <Form.Item className="d-none" name="num_customer">
                    <Input></Input>
                  </Form.Item>
                </Col>
              )}
            </Row>
            {numCustomer === 1 && !dataBooking?.seat_number && !loadingHold && !listBooking?.schedule?.is_diagram ? (
              <Spin spinning={loadingTicket}>
                <div className="segment-booking-block mt-3">
                  <div className="bg-segment">
                    <span>Chọn chặng</span>
                  </div>

                  <Row gutter={16}>
                    <Col span={16}>
                      <Form.Item
                        name="segment_id"
                        className="form-item-name require"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Select
                          className="input-h40"
                          placeholder="Chọn chặng"
                          size="large"
                          style={{ width: '100%' }}
                          options={[...listSegmentOption]}
                          showSearch
                          filterOption={filterOption}
                          suffixIcon={<img src={iconDown} alt="" />}
                          onChange={(value, option) => handleChangeSegment(value, option)}
                          optionRender={(option) => (
                            <>
                              <Space className="w-100 fw-500 text-color-default d-flex justify-between">
                                <div>
                                  {`${option?.data?.label}`}
                                  {option?.data?.price_schedule?.reason ? (
                                    <div className="text-success fs-13 fw-500">
                                      {getPriceScheduleReason(option?.data?.price_schedule, false)}
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>
                                <div className="available-seat-segment">{`Còn ${option?.data?.available_seats} chỗ`}</div>
                              </Space>
                            </>
                          )}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      {group === USER_GROUP.CAR_COMPANY ? (
                        <div className="agent-booking-block">
                          <div onClick={onChangeIsAgent} className={`h-fit`}>
                            <Form.Item
                              name="is_agent_id"
                              className="is-agent d-flex items-center justify-center"
                              valuePropName="checked"
                            >
                              <Checkbox />
                            </Form.Item>
                          </div>
                          <Form.Item name="agent_id" className="is-agent-select" required={isAgentId ? true : false}>
                            <Select
                              className="input-h40"
                              disabled={!isAgentId}
                              placeholder={
                                <div
                                  className="d-flex justify-center items-center "
                                  style={{ columnGap: '10px', width: '150px' }}
                                >
                                  <img src={iconBookingAgent} alt="" /> Đặt hộ đại lý
                                </div>
                              }
                              size="large"
                              options={[...listAgentActiveOption]}
                              showSearch
                              onChange={(value, option) => handleChangeAgentIdOption(option)}
                              filterOption={filterOptionAgent}
                              suffixIcon={<img src={iconDown} alt="" />}
                            />
                          </Form.Item>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="ticket-info-booking-block mt-4">
                  <div className="bg-ticket">
                    <span>{`Mã vé: ${formBooking.getFieldValue('ticket_code') ?? ''}`}</span>
                  </div>
                  <Row gutter={12}>
                    <Col span={6}>
                      <Form.Item
                        name="customer_phone"
                        className="require"
                        validateFirst
                        rules={[
                          {
                            required: true,
                            min: 6,
                            max: 20,
                            message: 'Vui lòng nhập SĐT hợp lệ',
                          },
                        ]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          className="input-h40 input-phone"
                          addonBefore={<img src={iconPhone} alt="" />}
                          placeholder={t('Nhập số điện thoại')}
                          size="large"
                          value={customerPhone}
                          onChange={(e) => handleInputChange(e.target.value)}
                          onBlur={() => onChangePhone(customerPhone)}
                          onWheel={(event) => event.currentTarget.blur()}
                          maxLength={12}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={9}>
                      <Form.Item name="customer_name" className="require" validateTrigger={['onChange', 'onBlur']}>
                        <Input
                          placeholder="Nhập họ và tên"
                          className="input-h40"
                          addonBefore={<img src={iconName} alt="" />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={9}>
                      <Form.Item
                        name="customer_email"
                        validateTrigger={['onChange', 'onBlur']}
                        rules={validatorEmailBooking}
                      >
                        <Input
                          placeholder="Nhập email"
                          className="input-h40"
                          addonBefore={<img src={iconEmail} alt="" />}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="pickup_location_id"
                        className="form-item-name require"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Select
                          showSearch
                          filterOption={filterOption}
                          className="input-h40"
                          placeholder={
                            <>
                              <img src={iconDepart} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                              đón
                            </>
                          }
                          size="large"
                          style={{ width: '100%' }}
                          options={handleOptionPickup()}
                          suffixIcon={<img src={iconDown} alt="" />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="drop_off_location_id"
                        className="form-item-name require"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Select
                          showSearch
                          filterOption={filterOption}
                          className="input-h40"
                          placeholder={
                            <>
                              <img src={iconArrive} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm
                              trả
                            </>
                          }
                          size="large"
                          style={{ width: '100%' }}
                          options={handleOptionDropOff()}
                          suffixIcon={<img src={iconDown} alt="" />}
                        />
                      </Form.Item>
                    </Col>

                    <Row gutter={20} className="w-100 mt-3" style={{ paddingLeft: '8px' }}>
                      {pickUpValue === 'other' && (
                        <Col span={12}>
                          <Form.Item
                            name="pickup_extra"
                            className="form-item-name require"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Input
                              className="input-h40"
                              placeholder="Chọn điểm đón khác"
                              size="large"
                              style={{ width: '100%', borderLeft: '1px solid #C3CAD7' }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {pickUpValue !== 'other' && dropOffValue === 'other' && <Col span={12}></Col>}
                      {dropOffValue === 'other' && (
                        <Col span={12}>
                          <Form.Item
                            name="drop_off_extra"
                            className="form-item-name require"
                            validateTrigger={['onChange', 'onBlur']}
                          >
                            <Input
                              className="input-h40"
                              placeholder="Nhập điểm trả khác"
                              size="large"
                              style={{ width: '100%', borderLeft: '1px solid #C3CAD7' }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Row>
                  <Row className="w-100 mt-0">
                    <Col span={3}>
                      <Typography className="fs-16 fw-500 text-blue">Loại ghế:</Typography>{' '}
                    </Col>
                    <Col span={21}>
                      <Form.Item name={'group_seat'} className="payment-checkbox-group group_seat">
                        <Radio.Group options={groupSeatOption()} />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                <div className="payment-booking-block mt-4">
                  <Flex align="center" justify="space-between" className="w-100">
                    <div className="bg-payment">
                      <span>Thanh toán</span>
                    </div>
                    <Col className="d-flex" style={{ columnGap: '11px' }}>
                      <Form.Item name="is_insurance" className="booking-input-disable">
                        <Switch
                          disabled={
                            !listBooking?.policy?.insurance_policy?.percent &&
                            !listBooking?.policy?.insurance_policy?.price
                          }
                        />
                      </Form.Item>
                      <div className="mt-2" style={{ columnGap: '5px' }}>
                        <Typography.Text className="fw-500 fs-14">
                          {t(
                            `Bảo hiểm chuyến đi (${
                              listBooking?.policy?.insurance_policy?.percent
                                ? `${listBooking?.policy?.insurance_policy?.percent}% giá vé`
                                : `${formattedPrice(listBooking?.policy?.insurance_policy?.price)}đ/ghế`
                            }) `,
                          )}
                        </Typography.Text>
                        <Tooltip title={'Xem chi tiết chính sách bảo hiểm'}>
                          <InfoCircleFilled style={{ color: '#F8B507' }} onClick={() => setOpenInfoInsurance(true)} />
                        </Tooltip>
                      </div>
                    </Col>
                  </Flex>
                  <Row gutter={20} className="w-100 mt-2">
                    <Col span={6}>
                      {group !== USER_GROUP.AGENT ? (
                        <Flex className="block-numpad-input">
                          <Form.Item name="total_price" label={t('Tổng tiền')} className="booking-input-disable price">
                            <InputNumber
                              suffix="VND"
                              disabled={!pin_code}
                              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                          <div className="btn-numpad" onClick={() => handleNumpadClick()} style={{ marginTop: '25px' }}>
                            <img src={pin_code ? iconCancelPinCode : iconNumpad} alt="" />
                          </div>
                        </Flex>
                      ) : (
                        <>
                          <Form.Item
                            name="total_price"
                            label={t('Tổng tiền vé')}
                            className="booking-input-disable price"
                          >
                            <Input suffix="VND" disabled />
                          </Form.Item>
                        </>
                      )}
                      {isInSurance && (
                        <Typography className="fs-14 fw-500 text-insurance">
                          {listBooking?.policy?.insurance_policy?.percent
                            ? `+${listBooking?.policy?.insurance_policy?.percent}% tiền bảo hiểm`
                            : `+${formattedPrice(listBooking?.policy?.insurance_policy?.price)}đ tiền bảo hiểm`}
                        </Typography>
                      )}
                    </Col>
                    {group === USER_GROUP.AGENT && (
                      <Col span={6}>
                        <Form.Item
                          name="commission_price"
                          label={t('Tổng tiền đại lý trả')}
                          className="booking-input-disable price"
                        >
                          <Input suffix="VND" disabled className="input-h40 d-flex items-center border-r-2" />
                        </Form.Item>
                        <Typography className="fs-14 fw-500 text-discount">
                          {`Đã trừ ${
                            listBooking?.schedule?.agent?.commission_percent
                              ? listBooking?.schedule?.agent?.commission_percent
                              : '0'
                          }% chiết khấu`}
                        </Typography>
                      </Col>
                    )}
                    {isAgentId && agentId && commissionPrice !== 0 ? (
                      <Col span={6}>
                        <Spin spinning={!commisionPrice}>
                          <Form.Item
                            name="commission_price"
                            label={t('Tổng tiền đại lý trả')}
                            className="booking-input-disable price"
                          >
                            <Input
                              suffix="VND"
                              disabled
                              onLoad={agentId}
                              onLoadedData={agentId}
                              className="input-h40 d-flex items-center border-r-2"
                            />
                          </Form.Item>
                          <Typography className="fs-14 fw-500 text-discount">{`Đã trừ ${commissionPrice}% chiết khấu`}</Typography>
                        </Spin>
                      </Col>
                    ) : (
                      ''
                    )}
                    <Col span={group === USER_GROUP.AGENT || (isAgentId && agentId) ? 12 : 18}>
                      <Form.Item name="note" label={t('Ghi chú')}>
                        <Input placeholder="Nhập ghi chú" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <Form.Item
                        name="payment_method"
                        label={t('Phương thức thanh toán')}
                        className="require"
                        required={true}
                      >
                        <Radio.Group
                          options={group !== USER_GROUP.AGENT ? paymentMultiOptions : paymentAgentOptions}
                          onChange={onChangePayment}
                          value={paymentMethod}
                          buttonStyle="solid"
                          className="payment-checkbox-group"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <Row className="mt-3">
                  <Col className="w-100">
                    <Row gutter={16} className="mt-2">
                      <Col span={5} className="d-none">
                        <Form.Item name="name_seat" label={t('Ghế đang chọn')} className="w-100 booking-input-disable">
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Spin>
            ) : (
              <Row className="tab-booking-container mt-3">
                <Col className="w-100">
                  <ModalMultiBooking1
                    dataBooking={dataBooking}
                    listBooking={listBooking}
                    formBooking={formBooking}
                    activeKey={activeKey}
                    numCustomer={numCustomer}
                    loadingHold={loadingHold || loadingCheckSegment}
                    isDepart={isDepart}
                    openModalNumpad={openModalNumpad}
                    setOpenModalNumpad={setOpenModalNumpad}
                    modalOpen={modalOpen}
                  />
                </Col>
              </Row>
            )}
            <Row className="d-flex justify-content-end" style={{ columnGap: '12px' }}>
              <Button key="cancel" className=" w-160 h-btn-48" onClick={() => modalHandleCancel()}>
                {cancelText}
              </Button>
              <Button
                key="ok"
                type="primary"
                className="w-160 h-btn-48 btn-success"
                style={{ marginRight: '5px' }}
                htmlType="submit"
              >
                {okText}
              </Button>
            </Row>
          </Form>
          <ModalNumpad
            modalOpen={openModalNumpad}
            onCancel={() => {
              setOpenModalNumpad(false);
              setOtp('');
            }}
            onOk={() => false}
            otp={otp}
            setOtp={setOtp}
          />
          <ModalInfoInsurance
            modalOpen={openInfoInsurance}
            onCancel={() => setOpenInfoInsurance(false)}
            onOk={() => false}
            listBooking={listBooking}
          />
        </Card>
      </Modal>
    </>
  );
};
export default ModalMultiBooking;
